import { render, staticRenderFns } from "./MetricEdit.vue?vue&type=template&id=1691d22c&scoped=true"
import script from "./MetricEdit.vue?vue&type=script&lang=js"
export * from "./MetricEdit.vue?vue&type=script&lang=js"
import style0 from "./MetricEdit.vue?vue&type=style&index=0&id=1691d22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1691d22c",
  null
  
)

export default component.exports